import { createTheme, responsiveFontSizes } from '@mui/material/styles';

// Design tokens - single source of truth
const tokens = {
  colors: {
    brand: {
      primary: '#667eea',
      secondary: '#764ba2',
      gradient: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    },
    status: {
      success: '#4caf50',
      warning: '#ff9800',
      error: '#f44336',
      info: '#2196f3',
    },
    neutral: {
      white: '#ffffff',
      background: '#f5f5f5',
      surface: '#ffffff',
      border: '#e0e0e0',
      textPrimary: '#212121',
      textSecondary: '#757575',
    },
  },
  shape: {
    borderRadius: 8,
    borderRadiusLarge: 12,
  },
  shadows: {
    card: '0 2px 8px rgba(0, 0, 0, 0.08)',
    cardHover: '0 4px 16px rgba(0, 0, 0, 0.12)',
  },
};

const baseTheme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: tokens.colors.brand.primary,
      contrastText: tokens.colors.neutral.white,
    },
    secondary: {
      main: tokens.colors.brand.secondary,
      contrastText: tokens.colors.neutral.white,
    },
    success: {
      main: tokens.colors.status.success,
    },
    warning: {
      main: tokens.colors.status.warning,
    },
    error: {
      main: tokens.colors.status.error,
    },
    info: {
      main: tokens.colors.status.info,
    },
    background: {
      default: tokens.colors.neutral.background,
      paper: tokens.colors.neutral.surface,
    },
    text: {
      primary: tokens.colors.neutral.textPrimary,
      secondary: tokens.colors.neutral.textSecondary,
    },
    divider: tokens.colors.neutral.border,
  },
  shape: {
    borderRadius: tokens.shape.borderRadius,
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      fontWeight: 700,
      fontSize: '2.5rem',
    },
    h2: {
      fontWeight: 600,
      fontSize: '2rem',
    },
    h3: {
      fontWeight: 600,
      fontSize: '1.5rem',
    },
    h4: {
      fontWeight: 600,
      fontSize: '1.25rem',
    },
    h5: {
      fontWeight: 500,
      fontSize: '1.125rem',
    },
    h6: {
      fontWeight: 500,
      fontSize: '1rem',
    },
    body1: {
      fontSize: '1rem',
      lineHeight: 1.6,
    },
    body2: {
      fontSize: '0.875rem',
      lineHeight: 1.5,
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          fontWeight: 500,
          borderRadius: tokens.shape.borderRadius,
        },
        containedPrimary: {
          background: tokens.colors.brand.gradient,
          '&:hover': {
            background: tokens.colors.brand.gradient,
            filter: 'brightness(1.1)',
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          boxShadow: tokens.shadows.card,
          borderRadius: tokens.shape.borderRadiusLarge,
          '&:hover': {
            boxShadow: tokens.shadows.cardHover,
          },
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: tokens.shape.borderRadius,
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            borderRadius: tokens.shape.borderRadius,
          },
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          fontWeight: 500,
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          background: tokens.colors.brand.gradient,
        },
      },
    },
  },
});

export const theme = responsiveFontSizes(baseTheme);
export { tokens };
